// Test IDs for public + admin pages
export const NAV = {
  header: 'site-header',
  headerLogo: 'site-header-logo',
  headerBenefitsLink: 'site-header-benefits-link',
  headerGridLink: 'site-header-grid-link',
  footer: 'footer',
  adminLoginLink: 'admin-login-link',
};

export const HERO = {
  primaryCta: 'hero-primary-cta-button',
  eyebrow: 'hero-eyebrow',
};

export const GRID = {
  animalTypeToggle: 'animal-type-toggle',
  toggleHorses: 'animal-type-toggle-horses',
  togglePonies: 'animal-type-toggle-ponies',
  tagFilter: 'tag-filter',
  tagFilterOption: (tag) => `tag-filter-option-${tag.toLowerCase().replace(/\s+/g, '-')}`,
  card: 'animal-card',
  cardName: 'animal-card-name',
  cardStateBadge: 'animal-card-state-badge',
  cardPrimaryCta: 'animal-card-primary-cta',
};

export const DETAIL = {
  page: 'animal-detail-page',
  sponsorButton: 'animal-detail-sponsor-button',
  shareButton: 'animal-detail-share-button',
  backButton: 'animal-detail-back-button',
};

export const ENQ = {
  openButton: 'enquiry-open-button',
  form: 'enquiry-form',
  fieldName: 'enquiry-form-name-input',
  fieldMembership: 'enquiry-form-membership-input',
  fieldEmail: 'enquiry-form-email-input',
  fieldPhone: 'enquiry-form-phone-input',
  fieldMessage: 'enquiry-form-message-input',
  submitButton: 'enquiry-form-submit-button',
  successState: 'enquiry-success-state',
  successClose: 'enquiry-success-close',
};

export const BENEFITS = { section: 'benefits-section' };
export const FAQ_TID = { accordion: 'faq-accordion' };

export const ADMIN = {
  loginPage: 'admin-login-page',
  loginEmail: 'admin-login-email-input',
  loginPassword: 'admin-login-password-input',
  loginSubmit: 'admin-login-submit-button',
  nav: 'admin-nav',
  navOpenButton: 'admin-nav-open-button',
  navDashboard: 'admin-nav-dashboard',
  navAnimals: 'admin-nav-animals',
  navEnquiries: 'admin-nav-enquiries',
  navSettings: 'admin-nav-settings',
  navAdmins: 'admin-nav-admins',
  navLogout: 'admin-nav-logout',
  dashboard: 'admin-dashboard',
  kpiCards: 'admin-kpi-cards',
  enquiryQueue: 'admin-enquiry-queue-table',
  animalsPage: 'admin-animals-page',
  animalRow: 'admin-animal-row',
  animalEditButton: 'admin-animal-edit-button',
  animalNewButton: 'admin-animal-new-button',
  animalEditor: 'admin-animal-editor',
  animalEditorSave: 'admin-animal-editor-save',
  animalPhotoUpload: 'admin-photo-upload-input',
  animalGallery: 'admin-gallery-sortable',
  enquiriesPage: 'admin-enquiries-page',
  enquiryRow: 'admin-enquiry-row',
  enquiryConfirmButton: 'admin-enquiry-confirm-button',
  enquiryDeclineButton: 'admin-enquiry-decline-button',
  settingsPage: 'admin-settings-page',
  settingsSave: 'admin-settings-save-button',
  adminsPage: 'admin-admins-page',
  adminNewButton: 'admin-admins-new-button',
};
